import React, { useState } from "react";
import PoliticaInversion from "../politica-inversion";
import GraficoProyecciones from "../grafico-proyecciones";
import LeyendaGraficoProyecciones from "../leyenda-grafico-proyecciones";
import * as Funciones from "../../../../utils/funciones";
import * as Constantes from "../../../../utils/constantes";
import styles from "./graficoRescates.module.css"

const GraficoRescates = ({ producto }) => {
    const initialState = {
        cantidadAnios: '',
        escenarios: producto.escenarios,
        fondos: producto.escenarios[0].descripcionFondo.split('\n')
    }

    const [ state, setState ] = useState(initialState)

    const onChangeInput = (valor, tipo) => {
        let escenariosAux = []
        let cantidadAnios = Funciones.obtenerValor(valor, tipo)
        producto.escenarios.map(escenario => {
            escenariosAux.push({
                ...escenario,
                proyecciones: escenario.proyecciones.filter(proyeccion =>
                    proyeccion.anio <= ((cantidadAnios !== '' && cantidadAnios !== 0) ? cantidadAnios : escenario.proyecciones.length))
            })
            return escenario
        })
        setState({
            ...state,
            cantidadAnios: cantidadAnios,
            escenarios: escenariosAux
        })
    }

    return (
        <React.Fragment>
            <div className={styles.contenedor}>
                <div className={styles.gb_anios}>
                    <input
                        className={styles.cantidad_anios}
                        placeholder='Elegir cantidad de años'
                        maxLength='2'
                        value={state.cantidadAnios}
                        onChange={(e) => onChangeInput(e.target.value, Constantes.TIPO_DATO_NUMERICO)}
                    />
                </div>

                <div className={styles.gb_cuentas}>
                    {state.fondos.map((fondo, index) => (
                        <span key={'fondo_' + index} className={styles.cuentas_fondo_span}>
                            {fondo}
                        </span>
                    ))}
                </div>

                <div className={styles.gb_politica}>
                    <PoliticaInversion />
                </div>
            </div>

            <GraficoProyecciones
                escenarios={state.escenarios}
                codigoMoneda={producto.moneda.codigo}
                cantidadAnios={state.cantidadAnios}
            />

            <LeyendaGraficoProyecciones
                escenarios={state.escenarios}
            />
        </React.Fragment>
    )
}

export default GraficoRescates;